import { useCallback as useCallbackDI } from 'react';
import { useRouterActions as useRouterActionsDI } from '@atlassian/react-resource-router';
import type { UseNavigateType } from './types.tsx';

export const useNavigate: UseNavigateType = ({
	href,
	target,
	onClick,
	// eslint-disable-next-line react-hooks/react-compiler
	useRouterActions = useRouterActionsDI,
	// eslint-disable-next-line react-hooks/react-compiler
	useCallback = useCallbackDI,
}) => {
	// eslint-disable-next-line react-hooks/react-compiler
	const { push } = useRouterActions();

	// eslint-disable-next-line react-hooks/react-compiler
	return useCallback(
		(event) => {
			onClick && onClick(event);

			if (event.ctrlKey || event.metaKey || event.defaultPrevented || target === '_blank') return;

			event.preventDefault();
			push(href);
		},
		[push, href, target, onClick],
	);
};
